import PersonaOfficeShell from "@/components/PersonaOfficeShell";
import {
  Users, UserCheck, Star, Globe, IdCard, Calendar, Search, TrendingUp,
} from "lucide-react";

/** L11 · Talent Management Agency dashboard.
 *  Commission model, exclusive roster. Distinct from Casting because
 *  the business runs on retained talent + brand pitches, not per-project
 *  callbacks. */
const CONFIG = {
  layer:            "L11",
  label:            "Talent Management Agency",
  testidPrefix:     "tm-office",
  accent:           "#A78BFA",
  Icon:             Star,
  expectedOrgType:  "talent_management_agency",
  blurb:            "Build & monetise your exclusive roster. Pitch talent to producers, brands and events.",
  showSponsorQueue: true,
  sponsorLabel:     "Roster Verifications",
  tiles: [
    {
      key: "roster", to: "/directory?kind=talent_model", TileIcon: Star,
      title: "Exclusive Roster",
      desc:  "The talent you represent — headshots, availability, rates, past campaigns.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "pitches", to: "/office/desks/pitch", TileIcon: TrendingUp,
      title: "Active Pitches",
      desc:  "Track brand · producer · event pitches for each of your talents.",
      chip: "Beta", chipTone: "beta",
    },
    {
      key: "bookings", TileIcon: Calendar,
      title: "Bookings Calendar",
      desc:  "Rate cards, exclusivity windows and roster-level availability.",
      chip: "Soon", chipTone: "soon",
    },
    {
      key: "discover", to: "/directory?kind=talent_model", TileIcon: Search,
      title: "Discover Talent",
      desc:  "Scout new signings from the full Call·Sheet talent directory.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "pending", to: "/pending-individuals", TileIcon: UserCheck,
      title: "Pending Verifications",
      desc:  "Approve talent who chose you as their verification sponsor.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "public-profile", to: "/office/public-profile", TileIcon: Globe,
      title: "Public Profile",
      desc:  "Your agency page — bookings enquiries land here from producers & brands.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "icard", to: "/icard", TileIcon: IdCard,
      title: "Owner iCard",
      desc:  "Your verified, co-branded identity card.",
      chip: "Live", chipTone: "live",
    },
  ],
};

export default function TalentManagementDashboard() {
  return <PersonaOfficeShell config={CONFIG} />;
}
